import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';

const EnergyMeterToggle = ({ active, onToggle }) => {
  const t = useTranslation();
  const tr = (key, fallback) => {
    const val = t(key);
    if (val && val !== key) return val;
    if (fallback !== undefined) return fallback;
    return key;
  };

  return (
    <button
      className={`em-btn em-toggle ${active ? 'em-toggle--on' : ''}`}
      type="button"
      onClick={onToggle}
      title={tr('ENERGY_METER', 'Energy Meter')}
    >
      <i className="fas fa-battery-half em-toggle__icon"></i>
      <span>{tr('ENERGY_METER', 'Energy Meter')}</span>
    </button>
  );
};

export default EnergyMeterToggle;
